import React, { Component, Fragment } from "react";
import Routes from "./routes";
import { BrowserRouter } from 'react-router-dom'
import GAInitialize from './components/GAInitialize'

class App extends Component {
  render() {
    return (<BrowserRouter><Fragment><Routes /><GAInitialize /></Fragment></BrowserRouter>)
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js